import { render } from "./Lotto.vue?vue&type=template&id=1161cebd"
import script from "./Lotto.vue?vue&type=script&lang=js"
export * from "./Lotto.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__